import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

export const StyledDDContainer = styled.div`
    display: flex;
    position: relative;
`;

export const StyledDropdownButton = styled.div`
    & .DropdownButton {
        & .DropdownButton-text {
            ${mixins.setFontVariant("input2", colorsPalettes.carbon[400])}
        }

        & .DropdownButton--triangle {
            color: ${colorsPalettes.carbon["400"]};
        }
    }

    & .DropdownButton:active {
        ${mixins.setFontVariant("input2", colorsPalettes.carbon[400])}
    }
`;
